import React, {Component} from "react";
import {PanelContainer} from "../../components/Panel";
import Map from "../../components/Map";
import MarkerFilterContext from "../../contexts/markerFilter";

//TODO:TJH - move Switch statement from IndexMap to here.
export default class PanelMapOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      panelOpen: true,
      //REDTAG:TJH - this is derived state, and a problem:
      //https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-controlled-component
      markerFilter: this.setupMarkerFilter()
    };

    this.setupMarkerFilter();
  }

  setupMarkerFilter() {
    let result = {};
    let {floor} = this.props;
    if (floor) {
      result = floor.markers().reduce((result, marker) => {
        result[marker.type_id] = false;
        return result;
      }, {});
    }

    return result;
  }

  render() {
    return (
      <MarkerFilterContext.Provider
        value={{
          markerFilter: this.state.markerFilter,
          toggleMarkerFilter: this.toggleMarkerFilter,
          toggleAllMarkerFilter: this.toggleAllMarkerFilter,
          getAllToggled: this.getAllToggled
        }}>
        <PanelContainer width={475} open={this.state.panelOpen} onToggle={this.handlePanelToggle}>
          <div className="mapPanelMobile">{this.props.panel}</div>
        </PanelContainer>
        <Map center={this.props.center}>{this.props.mapOverlay}</Map>
      </MarkerFilterContext.Provider>
    );
  }

  handlePanelToggle = () => {
    this.setState({panelOpen: !this.state.panelOpen});
  };

  toggleMarkerFilter = typeId => {
    let markerFilter = Object.assign({}, this.state.markerFilter);
    markerFilter[typeId] = !markerFilter[typeId];
    this.setState({markerFilter});
  };

  toggleAllMarkerFilter = () => {
    let toggleState = !this.getAllToggled();
    let markerFilter = Object.keys(this.state.markerFilter).reduce((result, key) => {
      result[key] = toggleState;
      return result;
    }, {});

    this.setState({markerFilter});
  };

  getAllToggled = () => {
    let {markerFilter} = this.state;
    let values = Object.values(markerFilter);
    return values.reduce((result, value) => {
      return result && value;
    }, values.length > 0);
  };
}



// WEBPACK FOOTER //
// ./src/pages/Map/PanelMapOverlay.jsx